import { useContext } from 'react';
import { NotificationContext } from '../components/wrappers/NotificationProvider';

const useNotifications = () => useContext(NotificationContext);

export default useNotifications;
